import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Config, TenantsService } from '@wdx/shared/utils';
import { throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { ConfigService } from '../services/config.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
    private authenticationService = inject(AuthenticationService);
    private environment = inject(ConfigService);
    private tenantsService = inject(TenantsService);


    intercept(request: HttpRequest<any>, next: HttpHandler) {
        const config = this.environment.getConfiguration();

        // if the request is to the portal (e.g. retrieving config.json or assets)
        // OR the request is to retrieve a token then ignore the interception
        // OR it's consent request
        if (
            request &&
            (this.isPortalRequest(request.url) ||
                this.isLoginRequest(config, request.url) ||
                this.isConsentRequest(config, request.url))
        ) {
            return next.handle(request);
        }

        return this.authenticationService.getTokenSilently$().pipe(
            mergeMap((token) => {
                const tokenReq = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        'x-clmi-tenant': this.tenantsService.tenantCode,
                    },
                });

                return next.handle(tokenReq);
            }),
            catchError((err) => throwError(err))
        );
    }

    private isPortalRequest(url: string): boolean {
        return !url || (url && url.indexOf('http') === -1);
    }

    private isLoginRequest(config: Config, url: string): boolean {
        return url && config && url.indexOf(`${config.API_BASE}/Login`) !== -1;
    }

    private isConsentRequest(config: Config, url: string): boolean {
        return (
            url && config && url.indexOf(`${config.API_BASE}/consent`) !== -1
        );
    }
}
